import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (
	item: TerminalAmountCellContent.Props["item"],
) => {
	if (!isNumber(item?.ordersCounters?.terminal?.amount)) return "";
	return formatNumber(item?.ordersCounters?.terminal?.amount);
};

const TerminalAmountCellContent: React.FC<TerminalAmountCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace TerminalAmountCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default TerminalAmountCellContent;
